const Logout = () => import('@/views/Pages/Logout.vue');
const Users = () => import('@/views/Pages/Users/Users.vue');
const Applications = () => import('@/views/Pages/Applications.vue');
const InviteUser = () => import('@/views/Pages/Users/InviteUser.vue');
const EditUser = () => import('@/views/Pages/Users/EditUser.vue');
const ManagePermissions = () => import('@/views/Pages/ManagePermissions.vue');
const Invoices = () => import('@/views/Pages/Invoices.vue');
const Contacts = () => import('@/views/Pages/Contacts.vue');
const Subscriptions = () => import('@/views/Pages/Subscriptions.vue');
const MyAccount = () => import('@/views/Pages/Settings/MyAccount.vue');
const ApiLogs = () => import('@/views/Pages/ApiLogs.vue');
const ContactSupport = () => import('@/views/Pages/ContactSupport.vue');

export default [
    {
        path: '/logout',
        name: 'Logout',
        component: Logout
    },
    {
        path: '/applications',
        name: 'ApplicationsPage',
        component: Applications,
        meta: {requiresAuth: true},
    },
    {
        path: '/users',
        name: 'UsersPage',
        component: Users,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
    },
    {
        path: '/invite-user',
        name: 'AddNewUserPage',
        component: InviteUser,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
    },
    {
        path: '/users/:userId',
        name: 'EditUserPage',
        component: EditUser,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
    },
    {
        path: '/manage-permissions',
        name: 'ManagePermissionsPage',
        component: ManagePermissions,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
    },
    {
        path: '/invoices',
        name: 'InvoicesPage',
        component: Invoices,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
    },
    {
        path: '/contacts',
        name: 'ContactsPage',
        component: Contacts,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
    },
    {
        path: '/subscriptions',
        name: 'SubscriptionsPage',
        component: Subscriptions,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
    },
    {
        path: '/my-account',
        name: 'MyAccountPage',
        component: MyAccount,
        meta: {requiresAuth: true},
    },
    {
        path: '/logs',
        name: 'ApiLogsPage',
        component: ApiLogs,
        meta: {
            requiresAuth: true,
            onlyAdmin: true,
        },
    },
    {
        path: '/contact-support',
        name: 'ContactSupportPage',
        component: ContactSupport,
        meta: {requiresAuth: true},
    },
]
